var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { replace } from 'lodash';
import { put, call, select, delay, } from 'redux-saga/effects';
import { _t } from '@hip/translations';
import { actions as utilsActions } from './actions';
import { fetchConfig } from './requests';
import { getRedirectUrl } from './selectors';
function init() {
    var config, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                return [4 /*yield*/, call(fetchConfig)];
            case 1:
                config = (_a.sent()).config;
                if (!config) return [3 /*break*/, 3];
                return [4 /*yield*/, put(utilsActions.setConfig(config))];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3: throw Error(_t('messages.error'));
            case 4: return [3 /*break*/, 6];
            case 5:
                e_1 = _a.sent();
                // TODO: add proper error handling
                console.log(e_1);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function redirectToNewHost() {
    var newHost, _a, e_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 5, , 6]);
                return [4 /*yield*/, select(getRedirectUrl)];
            case 1:
                newHost = _b.sent();
                if (!(newHost && window.location.host !== newHost)) return [3 /*break*/, 4];
                _a = window.location;
                return [4 /*yield*/, call(
                    // @ts-ignore
                    replace, window.location.href, window.location.host, newHost)];
            case 2:
                _a.href = _b.sent();
                return [4 /*yield*/, delay(1000)];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4: return [3 /*break*/, 6];
            case 5:
                e_2 = _b.sent();
                // TODO: add proper error handling
                console.log(e_2);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
export default function sagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(init)];
            case 1:
                _a.sent();
                return [4 /*yield*/, call(redirectToNewHost)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
